export default __webpack_public_path__ + "static/media/screen1.c94c1c42.png";